import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { tv } from 'tailwind-variants';
// import useSettings from '../../hooks/useSettings';

const checkbox = tv({
  base: 'bg-white border-0 cursor-pointer rounded-md shadow-sm accent-indigo-600 outline-none transition ease-in-out duration-150',
  slots: {
    label: 'text-slate-500 flex-1 cursor-pointer'
  },
  variants: {
    color: {
      primary: 'focus:ring-blue-500 focus:border-blue-500',
      error: 'border-red-500 focus:ring-red-500 focus:border-red-500'
    },
    size: {
      sm: 'px-3 py-2 text-sm',
      md: 'px-4 py-3 text-base w-4 h-4',
      lg: 'px-6 py-4 text-lg w-6 h-6'
    }
  },
  compoundSlots: [
    {
      slots: ['label'],
      size: 'sm',
      className: 'text-xs'
    },
    {
      slots: ['label'],
      size: 'md',
      className: 'text-sm'
    },
    {
      slots: ['label'],
      size: 'lg',
      className: 'text-md'
    }
  ],
  defaultVariants: {
    color: 'primary',
    size: 'md'
  }
});

type CheckboxProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size' | 'color'> & {
  name: string;
  label: string;
  color?: 'primary' | 'error';
  size?: 'sm' | 'md' | 'lg';
};

const Checkbox: React.FC<CheckboxProps> = ({
  color = 'primary',
  name,
  size = 'md',
  label,
  className,
  ...props
}) => {
  const { control } = useFormContext();
  // const { text } = useSettings();

  const { base: baseSlot, label: labelSlot } = checkbox({
    color: color,
    size: size
  });

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <div className={`flex flex-row w-full items-start gap-1 ${className}`}>
          <div className="flex flex-row gap-3 items-center justify-start">
            <input
              type="checkbox"
              className={baseSlot({ color: error ? 'error' : color, size })}
              id={name}
              {...field}
              {...props}
            />
            <label
              className={labelSlot({ color: error ? 'error' : color, size })}
              htmlFor={name}
              // style={{
              //   color: text?.color?.primary
              // }}
            >
              {label}
            </label>
          </div>
          {error && <span className="text-red-500 text-xs">{error.message}</span>}
        </div>
      )}
    />
  );
};

export default Checkbox;
